<template>
  <AIRiskDetail
    v-if="patientIdentifier"
    :patient-identifier="patientIdentifier"
  />
</template>

<script>
import AIRiskDetail from '@/components/Care_Management/Widgets/PatientEngagement/AIRiskDetail.vue';

export default {
  name: 'Patient_Insights',
  components: { AIRiskDetail },

  props: {
    patientIdentifier: { type: String, required: true },
    entityId: { type: Number, default: null }
  }
};
</script>
